import a from "./Draggable.vue2.js";
/* empty css               */
import o from "./_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ o(a, [["__scopeId", "data-v-a89d6a6e"]]);
export {
  m as default
};
